"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Description = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var Description_st_css_1 = require("./Description.st.css");
exports.Description = function (props) {
    if (!props.description) {
        return null;
    }
    return (React.createElement("p", { className: Description_st_css_1.st(Description_st_css_1.classes.root, props.className), "data-hook": "item-description", dangerouslySetInnerHTML: { __html: props.description } }));
};
//# sourceMappingURL=Description.js.map